import { Modal } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { TravelReferenceDocumentFile } from '../model/TravelReferenceDocumentTypes';
import { getTravelReferenceDocumentSlotLabel } from '../travelReferenceDocumentLabels';
import { TravelReferenceDocumentViewer } from './TravelReferenceDocumentViewer';

interface TravelReferenceDocumentPreviewModalProps {
  document: TravelReferenceDocumentFile;
  onClose: () => void;
}

export function TravelReferenceDocumentPreviewModal({ document, onClose }: TravelReferenceDocumentPreviewModalProps) {
  const { t } = useTranslation();
  const title = getTravelReferenceDocumentSlotLabel(t, document);

  return (
    <Modal
      opened
      centered
      onClose={onClose}
      title={title}
      size="90%"
    >
      <TravelReferenceDocumentViewer
        document={document}
        source="slot"
        title={title}
      />
    </Modal>
  );
}
